import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  canActivate(): boolean {
    if (this.authService.hasValidAccessToken()) {
      void this.router.navigate(['/dashboard']);
      return false;
    }

    if (this.authService.getToken()) {
      this.authService.removeToken();
    }

    return true;
  }
}
